import { Popup as LeafletPopup } from "react-leaflet";
interface Props {
  text: React.ReactNode | string;
}
const Popup = ({ text }: Props) => <LeafletPopup>{text}</LeafletPopup>;

export default Popup;
